import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const AuthAPI = {
  login: async function (data, cancel = false) {
    const response = await api.request({
      url: "/login",
      method: "POST",
      data: data,
      signal: cancel ? cancelApiObject[this.login.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },
  logout: async function (data, cancel = false) {
    const response = await api.request({
      url: "/logout",
      method: "POST",
      data: data,
      signal: cancel ? cancelApiObject[this.logout.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },
  forgot: async function (data, cancel = false) {
    const response = await api.request({
      url: "/forgot",
      method: "POST",
      data: data,
      signal: cancel ? cancelApiObject[this.forgot.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },
  reset: async function (data, cancel = false) {
    const response = await api.request({
      url: "/reset",
      method: "POST",
      data: data,
      signal: cancel ? cancelApiObject[this.reset.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },
}

// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(AuthAPI)